import { FakeData } from "components/widget/CTable"
import Table from "components/widget/CTable/Table"

export const AllContacts = () => {

    const col = [
        {
          title: "Invoice ",
          render: (i: any) => (<>{i?.invoice}</>)
        },
        {
          title: "Package ",
          render: (i: any) => (<>{i?.package}</>)
        },
        {
          title: "Price ",
          render: (i: any) => (<>{i?.price}</>)
        },
        {
          title: "Invoice Date ",
          render: (i: any) => (<>{i?.Invoice_Date}</>)
        },
        {
          title: "Status",
          render: (i: any) => (
            <>
              {i.status == 0 && <span className="text-green-600">Enable</span>}
              {i.status == 1 && <span  className="text-[#FFA500]">Disable</span>}
            </>
          )
        },
        {
          title: "Change Status",
          render: (i: any) => (
          <>
          <div className={`w-[60px] h-[27px]  cursor-pointer  shadow border border-hoory-175 flex items-center rounded-full px-1 ${i.status == 0 ? 'justify-start bg-hoory-125' : 'justify-end bg-hoory-125'}`}>
            <div className={`w-[20px] h-[20px] rounded-full ${i.status == 0 ? 'bg-blue-400' : 'bg-blue-400'}  `}></div>
          </div>
          </>
          )
        },
      ]


    return (
        <div className="w-full flex flex-col md:p-[20px] p-[10px] bg-hoory-100  rounded-lg">
            <Table columns={col} data={FakeData}  />
        </div>
    )
}